(function (){
    'use strict';

    angular
        .module('services')
        .service('CostCentersService', CostCentersService);

    CostCentersService.$inject = ['CostCenter', '$http', 'API_BASE'];

    /* @ngInject */
    function CostCentersService (CostCenter, $http, API_BASE) {
        var service = this;

        /* CostCenter repository methods */
        service.createCostCenter = createCostCenter;
        service.updateCostCenter = updateCostCenter;
        service.listCostCenters = listCostCenters;
        service.deleteCostCenter = deleteCostCenter;
        service.getAllCostCenters = getAllCostCenters;
        service.getByFilter     = getByFilter;

        // CostCenters Pagination
        service.costCenters = [];
        service.totalItems = 0;
        service.to = 0;
        service.itemsPerPage = 0;
        
        function createCostCenter(data) {
            return new CostCenter(prepareData(data)).save();
        }

        function updateCostCenter(data) {
            return new CostCenter({id: data.id}).update(prepareData(data));
        }
        
        function listCostCenters(query) {
            return CostCenter.where(query)
                .then(res => {
                    service.costCenters = res.data.data;
                    service.totalItems = res.data.total;
                    service.to = res.data.to;
                    service.itemsPerPage = res.data.per_page;
                    service.currentPage = res.data.current_page;

                    return service;
                });
        } 

        function deleteCostCenter(id) {
            return CostCenter.destroy(id);
        }
        
        function getAllCostCenters() {
            return CostCenter.all();
        } 
        
        function prepareData(data) {
            return {
                name: data.name,
                parent_id: data.parent && data.parent.id
            };
        }

        function getByFilter (query) {
            return $http.get(API_BASE + '/cost_centers',{params:query});
        }
    }
})();